export default __webpack_public_path__ + "static/media/abstract_blue.9b3377a4.jpg";